export default __webpack_public_path__ + "static/texture-021b5a55b630cfeb6e9c2f51248a498e.jpg";